/* AM:BITION theme — minimal interactive layer */
(function () {
  'use strict';

  // ---- Cart drawer ----
  const overlay = document.querySelector('[data-cart-overlay]');
  const drawer = document.querySelector('[data-cart-drawer]');
  const openCart = () => { drawer && drawer.classList.add('open'); overlay && overlay.classList.add('open'); };
  const closeCart = () => { drawer && drawer.classList.remove('open'); overlay && overlay.classList.remove('open'); };

  document.querySelectorAll('[data-cart-toggle]').forEach(el => {
    el.addEventListener('click', e => { e.preventDefault(); openCart(); });
  });
  document.querySelectorAll('[data-cart-close]').forEach(el => el.addEventListener('click', closeCart));
  overlay && overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });

  // ---- Refresh cart drawer from /cart.js ----
  const refreshCart = async () => {
    try {
      const res = await fetch('/?section_id=cart-drawer'); // optional: implement section rendering
      // Simple count refresh:
      const cart = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);
    } catch (e) { /* noop */ }
  };

  // ---- Add to cart (AJAX) ----
  document.querySelectorAll('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const formData = new FormData(form);
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST', body: formData, headers: { 'Accept': 'application/json' }
        });
        if (!res.ok) throw new Error('Add to cart failed');
        await refreshCart();
        openCart();
      } catch (err) {
        console.error(err);
        form.submit(); // graceful fallback
      }
    });
  });

  // ---- Quantity ----
  document.querySelectorAll('[data-qty-down]').forEach(btn => btn.addEventListener('click', () => {
    const input = btn.parentElement.querySelector('input');
    input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
  }));
  document.querySelectorAll('[data-qty-up]').forEach(btn => btn.addEventListener('click', () => {
    const input = btn.parentElement.querySelector('input');
    input.value = parseInt(input.value || '1', 10) + 1;
  }));

  // ---- Variant selector (flavor / option buttons) ----
  const variantsEl = document.querySelector('[data-variants]');
  if (variantsEl) {
    let variants = [];
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) {}
    const optionState = {};
    document.querySelectorAll('.flavor-opt.active').forEach(b => {
      const name = b.dataset.optionName;
      if (name) optionState[name] = b.dataset.optionValue;
    });

    const findVariant = () => variants.find(v => {
      return Object.keys(optionState).every((name, i) => v.options[i] === optionState[name]);
    });

    document.querySelectorAll('.flavor-opt[data-option-name]').forEach(btn => {
      btn.addEventListener('click', () => {
        const name = btn.dataset.optionName;
        document.querySelectorAll(`.flavor-opt[data-option-name="${name}"]`)
          .forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        optionState[name] = btn.dataset.optionValue;
        const v = findVariant();
        if (v) {
          document.querySelectorAll('[data-variant-id]').forEach(el => el.value = v.id);
          if (v.featured_image && v.featured_image.src) {
            const main = document.getElementById('MainProductImg');
            if (main) main.src = v.featured_image.src;
          }
          const priceEl = document.querySelector('.product-info .price');
          if (priceEl) priceEl.textContent = (v.price / 100).toLocaleString(undefined,
            { style: 'currency', currency: window.Shopify ? Shopify.currency.active : 'EUR' });
        }
      });
    });
  }

  // ---- Gallery thumbs ----
  document.querySelectorAll('[data-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('[data-thumb]').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const main = document.getElementById('MainProductImg');
      if (main) main.src = thumb.dataset.img;
    });
  });

  // ---- Accordion ----
  document.querySelectorAll('[data-acc]').forEach(btn => {
    btn.addEventListener('click', () => btn.parentElement.classList.toggle('open'));
  });

  // ---- Cart line item update ----
  const updateLine = async (key, qty) => {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    if (res.ok) location.reload(); // simple — drawer reloads with new state
  };
  document.querySelectorAll('[data-cart-qty-up]').forEach(btn => btn.addEventListener('click', () => {
    const key = btn.dataset.cartQtyUp;
    const span = btn.previousElementSibling;
    updateLine(key, parseInt(span.textContent, 10) + 1);
  }));
  document.querySelectorAll('[data-cart-qty-down]').forEach(btn => btn.addEventListener('click', () => {
    const key = btn.dataset.cartQtyDown;
    const span = btn.nextElementSibling;
    updateLine(key, Math.max(0, parseInt(span.textContent, 10) - 1));
  }));
})();
